export const SET_RESOURCES_IN_PLACE = 'SET_RESOURCES_IN_PLACE';
export const SET_CODES_IN_PLACE = 'SET_CODES_IN_PLACE';
export const SET_LEVEL_IN_THE_WIDGET = 'SET_LEVEL_IN_THE_WIDGET';
export const SET_RES_IN_PLACE_BY_HOURS = 'SET_RES_IN_PLACE_BY_HOURS';